import { HttpErrorResponse } from '@angular/common/http';

/** Texto que arma Angular para cualquier HTTP fallido. No le dice nada al socio. */
const ANGULAR_HTTP_MESSAGE = /^Http failure/i;

export function resolveErrorMessage(error: unknown, fallback: string): string {
	const detail = readDetail(error)?.trim();
	return detail || fallback;
}

function readDetail(error: unknown): string | null {
	if (typeof error === 'string') {
		return unwrapNestedDetail(error);
	}
	if (!error || typeof error !== 'object') {
		return null;
	}
	const body = (error as HttpErrorResponse).error;
	return readBodyDetail(body) ?? readOwnMessage(error);
}

function readBodyDetail(body: unknown): string | null {
	if (typeof body === 'string') {
		return unwrapNestedDetail(body);
	}
	if (!body || typeof body !== 'object') {
		return null;
	}
	const candidate = body as {
		detail?: unknown;
		mensaje?: unknown;
		message?: unknown;
	};
	const values = [candidate.detail, candidate.mensaje, candidate.message];
	for (const value of values) {
		if (typeof value === 'string' && value.trim()) {
			return unwrapNestedDetail(value);
		}
	}
	return null;
}

function readOwnMessage(error: unknown): string | null {
	const message = (error as Error).message;
	if (typeof message !== 'string' || !message.trim()) {
		return null;
	}
	return ANGULAR_HTTP_MESSAGE.test(message)
		? null
		: unwrapNestedDetail(message);
}

function unwrapNestedDetail(text: string): string {
	const nested = text.match(/"detail"\s*:\s*"([^"]+)"/);
	return nested?.[1] ?? text;
}
